export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    loading: state => state.loading
  },
  mutations: {
    setAll(state, chats) {
      state.all = chats
      state.loading = false
    },
    set(state, chat) {
      state.all = state.all.filter(o => o.id != chat.id)
      state.all.push(chat)
    },
  },
  actions: {
    fetchAll({ state, commit }) {
      state.loading = true
      return Vue.$http
        .get('client/chats')
        .then(response => commit('setAll', response.data), () => (state.loading = false))
    },
    fetchApplication({ state, commit }, application) {
      state.loading = true
      return Vue.$http
        .get(`client/opportunities/${application.opportunity.id}/applications/${application.id}/chats`)
        .then(response => {
          response.data.forEach(chat => commit('set', chat))
        })
        .finally(() => (state.loading = false))
    },
  }
}
